import { defineMessage } from 'react-intl'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const nikeathletehealth: GetCustomerCopyFunc = () => ({
  generateEligibilityQuestionTitle: () =>
    defineMessage({
      defaultMessage: 'Are you a member of Nike, Inc. Contracted Athletes or authorized by Nike to use this service?',
      description: 'Asking if the user is a Nike contracted athlete or authorized to use the service',
    }),
})
